
export const WordCountParser = {
    parse: (stringToParse: string ) => {

    const wordCount = stringToParse.replace(/<(?:.|\n)*?>/gm, ' ').match(/\b\S+\b/g);

    return wordCount !== null ? wordCount.length : 0;
    },
};

export default WordCountParser;